define([
    'common/domain/action/index',
    'system/domain/entity/tag',
    'system/domain/entity/tag-category',
    'system/domain/collection/tag',
    'system/domain/collection/tag-category',
    'common/domain/repository/dispatcher',
    'backbone'
], function(
    Actions,
    TagModel,
    TagCategoryModel,
    TagCollection,
    TagCategoryCollection,
    Dispatcher,
    Backbone
    ) {
    const TagStore = Backbone.Model.extend({
        initialize: function() {
            _.bindAll(this, 'dispatch');
            this._contextTags = {};
            this._contextCategories = {};
            Dispatcher.register(this.dispatch);
        },

        _tags: function(context) {
            var key = context.projectId;
            var tags = this._contextTags[key];
            if(tags) {
                return tags;
            }
            this._contextTags[key] = new TagCollection();
            return this._contextTags[key];
        },

        _categories: function(context) {
            var key = context.projectId;
            var categories = this._contextCategories[key];
            if(categories) {
                return categories;
            }
            this._contextCategories[key] = new TagCategoryCollection();
            return this._contextCategories[key];
        },

        clearAll: function() {
            this._contextTags = {};
            this._contextCategories = {};
        },

        getTags: function(params) {
            return this._tags(params.context);
        },

        getCategories: function(params) {
            return this._categories(params.context);
        },

        findTags: function(params) {
            var exact = params.options && params.options.exact == true;
            return this._tags(params.context).filter(function(model){
                if(model.get('deleted')) {
                    return false;
                }
                if(exact) {
                    return model.get('name') == params.query;
                } else {
                    return model.get('name').indexOf(params.query) >= 0;
                }
            });
        },

        dispatch: function(action) {
            switch(action.type) {
                case Actions.CREATE_TAG:
                    this._createTag(action);
                    break;
                case Actions.UPDATE_TAG:
                    this._updateTag(action);
                    break;
                case Actions.DELETE_TAG:
                    this._deleteTag(action);
                    break;
                case Actions.TOGGLE_TAG:
                    this._toggleTag(action);
                    break;
                case Actions.CATEGORIZE_TAG:
                    this._categorizeTag(action);
                    break;
                case Actions.CREATE_TAG_CATEGORY:
                    this._createCategory(action);
                    break;
                case Actions.UPDATE_TAG_CATEGORY:
                    this._updateCategory(action);
                    break;
                case Actions.DELETE_TAG_CATEGORY:
                    this._deleteCategory(action);
                    break;
                case Actions.TOGGLE_TAG_CATEGORY:
                    this._toggleCategory(action);
                    break;
            }
        },

        _createTag: function(action) {
            var _tags = this._tags(action.context);
            var tags = [];
            if(!action.tag) {
                return;
            }

            var categories = this._categories(action.context);

            if(_.isArray(action.tag)){
                tags = _.map(action.tag, function(j) {
                    return new TagModel(j, {categories: categories});
                });
            } else {
                tags = [new TagModel(action.tag, {categories: categories})];
            }

            // fetch されたならパフォーマンスのために reset のみ飛ばす
            if(action.options && action.options.fetched) {
                _tags.add(tags, {merge: true, silent: true});
                _tags.trigger('reset');
            } else {
                _tags.add(tags, {merge: true});
            }
        },

        _updateTag: function(action) {
            var _tags = this._tags(action.context);
            if(!action.tag) {
                return;
            }

            var tags = _.isArray(action.tag) ? action.tag : [action.tag];
            _.each(tags, function(j) {
                var tag = _tags.get(j.id);
                if(tag) {
                    tag.set(j);
                }
            });
        },

        _deleteTag: function(action) {
            var _tags = this._tags(action.context);
            if(!action.tag) {
                return;
            }

            var tags = _.isArray(action.tag) ? action.tag : [action.tag];
            _.each(tags, function(j) {
                var tag = _tags.get(j.id);
                if(tag) {
                    _tags.remove(tag);
                }
            });
        },

        _toggleTag: function(action) {
            var _tags = this._tags(action.context);
            if(!action.tag) {
                return;
            }

            var tags = _.isArray(action.tag) ? action.tag : [action.tag];
            _.each(tags, function(j) {
                var tag = _tags.get(j.id);
                if(tag) {
                    tag.toggle();
                }
            });
        },

        _categorizeTag: function(action) {
            var _tags = this._tags(action.context);
            var _categories = this._categories(action.context);
            if(!action.tag ||
                (action.category && action.category.id &&
                    !_categories.get(action.category.id))) {
                return;
            }

            var tags = _.isArray(action.tag) ? action.tag : [action.tag];
            _.each(tags, function(j) {
                var tag = _tags.get(j.id);
                if(tag) {
                    if(!action.category) {
                        tag.set({category: null});
                    } else {
                        tag.set({category: action.category.id});
                    }
                }
            });
        },

        _createCategory: function(action) {
            var _categories = this._categories(action.context);
            var categories = [];
            if(!action.category) {
                return;
            }

            if(_.isArray(action.category)){
                categories = _.map(action.category, function(j) {
                    return new TagCategoryModel(j);
                });
            } else {
                categories = [new TagCategoryModel(action.category)];
            }

            // fetch されたならパフォーマンスのために reset のみ飛ばす
            if(action.options && action.options.fetched) {
                _categories.add(categories, {merge: true, silent: true});
                _categories.trigger('reset');
            } else {
                _categories.add(categories, {merge: true});
            }
        },

        _updateCategory: function(action) {
            var _categories = this._categories(action.context);
            if(!action.category) {
                return;
            }

            var categories = _.isArray(action.category) ?
                action.category : [action.category];
            _.each(categories, function(j) {
                var category = _categories.get(j.id);
                if(category) {
                    category.set(j);
                }
            });
        },

        _deleteCategory: function(action) {
            var _categories = this._categories(action.context);
            if(!action.category) {
                return;
            }

            var categories = _.isArray(action.category) ?
                action.category : [action.category];
            _.each(categories, function(j) {
                var category = _categories.get(j.id);
                if(category) {
                    var tags = this.getTags({
                        context: action.context
                    }).where({category: category.id});

                    this._categorizeTag({
                        context: action.context,
                        category: null,
                        tag: _.map(tags, function(tag){
                            return {id: tag.id}})
                    });
                    _categories.remove(category);
                }
            }, this);
        },

        _toggleCategory: function(action) {
            var _categories = this._categories(action.context);
            if(!action.category) {
                return;
            }

            var categories = _.isArray(action.category) ?
                action.category : [action.category];
            _.each(categories, function(j) {
                var category = _categories.get(j.id);
                if(category) {
                    category.toggle();
                }
            });
        }
    });

    return new TagStore();
});



// WEBPACK FOOTER //
// ./system/domain/repository/tag.js